import { buildProps } from "@xplus/utils/props";
import type { ExtractPropTypes } from "vue";

export const switchProps = buildProps({
  size: {
    type: String,
    default: "normal",
    values: ["normal", "mini"],
  },
} as const);

export type SwitchProps = ExtractPropTypes<typeof switchProps>;
